export const prefix = '[Instruments]';
